import React, { useCallback } from 'react';

import useQueryInfoQuery from '../hooks/store/useQueryInfoQuery';
import useSearchPaginationStore from '../hooks/store/useSearchPaginationStore';
import useSelectedFiltersStore from '../hooks/store/useSelectedFiltersStore';
import useSearchQueryParam from '../hooks/store/useSearchQueryParam';
import SearchPageComponent from '../components/SearchPage';

const SearchPage = () => {

    const { searchQuery, queryType } = useSearchQueryParam();
    const { error } = useQueryInfoQuery(searchQuery, queryType);
    const { setPage } = useSearchPaginationStore();
    const { setSelectedFilters } = useSelectedFiltersStore();

    const resetPageNumber = useCallback(() => setPage(0),[setPage]);

    return (
        <SearchPageComponent
            query={searchQuery}
            queryInfoError={error}
            resetPageNumber={resetPageNumber}
            setSelectedFilters={setSelectedFilters}
        />
    );

};

export default SearchPage;
